var map = {
	"./ArrowDownIcon.svg": "d1bd",
	"./ArrowUpIcon.svg": "dd76",
	"./BarsIcon.svg": "725d",
	"./BarsNotificationIcon.svg": "449b",
	"./BellIcon.svg": "b171",
	"./BusinessIcon.svg": "7737",
	"./CalendarIcon.svg": "636e",
	"./CategoryNotificationIcon.svg": "6071",
	"./CheckGrayIcon.svg": "6284",
	"./CheckGreenIcon.svg": "601e",
	"./CheckedIcon.svg": "8f9f",
	"./CircleIcon.svg": "7e95",
	"./CloseIcon.svg": "0468",
	"./CloudUploadIcon.svg": "517e",
	"./DatabaseIcon.svg": "b9fe",
	"./DeleteBlueIcon.svg": "2379",
	"./DeleteGrayIcon.svg": "3b27",
	"./DiscountIcon.svg": "030b",
	"./DiscountNotificationIcon.svg": "7a47",
	"./DoctorIcon.svg": "8a9c",
	"./DownloadFileIcon.svg": "9b8a",
	"./EditBlueIcon.svg": "ebe3",
	"./EditCircleBlueIcon.svg": "4270",
	"./EditCircleWhiteIcon.svg": "2a34",
	"./EditGrayIcon.svg": "9a10",
	"./ExcelIcon.svg": "b684",
	"./Eye.svg": "dba8",
	"./Eye2.svg": "06d1",
	"./EyeBlue.svg": "016d",
	"./FileTextIcon.svg": "2830",
	"./HeadphoneIcon.svg": "dc8d",
	"./HeadphonesNotificationIcon.svg": "4c9a",
	"./HomeIcon.svg": "b6a6",
	"./InventoryNotificationIcon.svg": "3e54",
	"./JpgFileIcon.svg": "85ea",
	"./ListIcon.svg": "c2e2",
	"./LogoutIcon.svg": "40e1",
	"./MarkerIcon.svg": "2776",
	"./MessageNotificationIcon.svg": "8243",
	"./MinusCircleIcon.svg": "a5d4",
	"./NotificationIcon.svg": "b6ba",
	"./OrdersIcon.svg": "a1e3",
	"./PinIcon.svg": "f85e",
	"./PlusCircleBlueFilledIcon.svg": "d40e",
	"./PlusCircleBlueIcon.svg": "5b75",
	"./PlusCircleGrayIcon.svg": "617f",
	"./PlusCircleIcon.svg": "1d0a",
	"./ProductsIcon.svg": "7390",
	"./ProductsNotificationIcon.svg": "971e",
	"./ShoppingBagIcon.svg": "b4ca",
	"./ShoppingCartNotificationIcon.svg": "1b95",
	"./StoreIcon.svg": "0e6d",
	"./StoreNotificationIcon.svg": "fc37",
	"./TagIcon.svg": "05e6",
	"./UploadFileIcon.svg": "2437",
	"./UserIcon.svg": "33a3",
	"./UserLockedIcon.svg": "28cd",
	"./UserNotificationIcon.svg": "1590",
	"./UserWhiteIcon.svg": "1926",
	"./UsersIcon.svg": "7de8",
	"./UsersNotificationIcon.svg": "3b0c",
	"./ZipFileIcon.svg": "c2b8",
	"./ZoneNotificationIcon.svg": "0174"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";